import { gql } from '@apollo/client'

export const SERVER_TIME = gql`
  query getServerTime {
    getServerTime {
      serverTime
    }
  }
`
